import React, { useEffect, useRef } from "react";
import { Typography, Box, Link as MuiLink } from "@mui/material";
import { useTranslation } from "react-i18next";
import Lottie from "lottie-react";

import MaskSelectorToolStyles from "./MaskSelectorToolStyles.js";
import lottie_success_animation from "./img/lottie_success_animation.json";

const CompletePage = () => {
  const animationOptions = {
    loop: false,
    autoplay: true,
    controls: false,
    animationData: lottie_success_animation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const { t } = useTranslation("pages.MaskSelectorTool.CompletePage");
  const { classes } = MaskSelectorToolStyles();

  // Localization Strings
  const thankYouMessage = t("thankYouMessage");
  const completionMessage = t("completionMessage");
  const contactMessage = t("contactMessage");

  const thankYouRef = useRef(null);

  useEffect(() => {
    if (thankYouRef.current) {
      thankYouRef.current.focus();
    }
  }, []);

  return (
    <Box paddingY="24px">
      <Box className={classes.centeredBox}>
        <Box sx={{ width: "160px", height: "160px" }}>
          <Lottie {...animationOptions} data-testid="completeAnimation" />
        </Box>
      </Box>
      <Typography
        className={classes.res_provider_header}
        data-testid="complete-page-title"
        ref={thankYouRef}
      >
        {thankYouMessage}
      </Typography>
      <Typography
        sx={{ fontSize: "16px", fontWeight: "400", marginBottom: "16px" }}
        data-testid="complete-page-description"
      >
        {completionMessage}
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "flex-start", sm: "center" },
          gap: 1,
        }}
      >
        <Typography
          className={classes.res_small_paragraph}
          data-testid="complete-page-contact"
          sx={{ whiteSpace: "inline" }}
        >
          {contactMessage}
        </Typography>
        <MuiLink
          href="mailto:privacy@resmed.com"
          sx={{
            fontSize: "16px",
            fontWeight: 600,
            textDecoration: "none",
            whiteSpace: "nowrap",
            "&:hover": {
              textDecoration: "underline",
            },
          }}
          className={classes.res_captionLink}
          data-testid="email-link"
        >
          privacy@resmed.com
        </MuiLink>
      </Box>
    </Box>
  );
};

export default CompletePage;
